import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Youtube.css'
import { Link } from 'react-router-dom'
import { db } from './config';

const Youtube = () => {
  const [videos, setVideos] = useState([]);
  const [title, setTitle] = useState('');
  const [response, setResponse] = useState('');
  const [respondedVideos, setRespondedVideos] = useState([]);
  const [quotaExceeded, setQuotaExceeded] = useState(false);
  const [apiKeyIndex, setApiKeyIndex] = useState(0); // Keeps track of which API key to use
  const apiKeys = ['AIzaSyDpAVsOKCOyB0dt7CSNKNSoTuJoIKuReqI', 'AIzaSyAX2aKhQ7jv3v_JyCP7bOkSlDzChLaFVao', 'AIzaSyDXiOcS-Z5cqzh1Cv8Jswm-SJYxrPQI4vA', 'AIzaSyCXU-c9ICQl417Abp3midtX1oHcF0psG50', 'AIzaSyDRN3BWPL0L0YRt-D7vWj_z3T3m9ale8Tc', 'AIzaSyDg0VEJBrAyUiRpE3BNqb5nr_JC_MG4wxE', 'AIzaSyD23zh-HWHTX7kNBUEtEBvNk9tHiOHZKak', 'AIzaSyDSy_n6TdzOaRmzBVgvh7ReS6AiZlcRwGM']; // List of API keys to use

  const fetchData = async () => {
    try {
      const response = await axios.get(
        'https://www.googleapis.com/youtube/v3/search',
        {
          params: {
            key: apiKeys[apiKeyIndex],
            part: 'snippet',
            type: 'video',
            q: 'news',
            maxResults: 50,
            regionCode :'US',
            videoDuration: 'long',
            relevanceLanguage: 'en',
          },
        }
      );
      setVideos(response.data.items);
      setQuotaExceeded(false); // Reset the quota exceeded flag if the API call succeeds
    } catch (error) {
      if (error.response && error.response.status === 403) {
        setQuotaExceeded(true);
        if (apiKeyIndex < apiKeys.length - 1) {
          // Switch to the next API key if available
          setApiKeyIndex(apiKeyIndex + 1);
        }
      } else {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [apiKeyIndex]); 

  useEffect(() => {
    const unsubscribe = db.collection('news').onSnapshot(snapshot => {
      const respondedVideoIds = snapshot.docs.map(doc => doc.data().title);
      setRespondedVideos(respondedVideoIds);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    if (title && response) {
      db.collection('news').add({
        title: title,
        response: response,
      })
      .then(() => {
        console.log('Document successfully written!');
      })
      .catch((error) => {
        console.error('Error writing document: ', error);
      });
    }
  }, [title, response]);

  const handleResponse = (e, video) => {
    e.preventDefault();
    setTitle('');
    if (e.target.value === 'Yes') {
      setResponse('Yes');
      setVideos(videos.filter(v => v.id.videoId !== video.id.videoId));
    } else if (e.target.value === 'No') {
      setResponse('No');
      setVideos(videos.filter(v => v.id.videoId !== video.id.videoId));
    } else if (e.target.value === 'Not Sure') {
      setResponse('Not Sure');
      setVideos(videos.filter(v => v.id.videoId !== video.id.videoId));
    }
  };

  const filteredVideos = videos.filter(video => !respondedVideos.includes(video.snippet.title));

  return (
    <div className='video_card'>
      {quotaExceeded ? (
        <h1 className='sorry'>Thank You for your responses. Please check back letter to give more responses.</h1>
      ) : (

      <>
      <h1 className='question'>Is this a Clickbait ?</h1>
      <div className='topics'>
        <Link to='/technology'>
        <button className='topic_btn'>Technology</button>
        </Link>
        <Link to='/bollywood'>
        <button className='topic_btn'>Movies</button>
        </Link>
        <Link to='/politics'>
        <button className='topic_btn'>Politics</button>
        </Link>
        <Link to='/sports'>
        <button className='topic_btn'>Sports</button>
        </Link>
        <Link to='/news'>
        <button className='topic_btn'>News</button>
        </Link>
      </div>
      
      <ul>
        {filteredVideos.map((video, index) => (
          <li key={video.id.videoId}>
            <a
              href={`https://www.youtube.com/watch?v=${video.id.videoId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={video.snippet.thumbnails.high.url}
                alt={video.snippet.title}
                className='thumbnail'
              />
              
            </a>
            <p className='title' type='text'>{video.snippet.title}</p>
            <div className='yes_no'>
              <button onClick={(e) => {handleResponse(e, video.id.videoId); setTitle(video.snippet.title); setResponse('Yes')}} className='clickbait'>Yes</button>
              <button onClick={(e) => {handleResponse(e, video.id.videoId); setTitle(video.snippet.title); setResponse('No')}} className='clickbait'>No</button>
              <button onClick={(e) => {handleResponse(e, video.id.videoId); setTitle(video.snippet.title); setResponse('Not Sure')}} className='clickbait'>Not Sure</button>
            </div>
          </li>
        ))}
      </ul>
      </>
      )}
      <footer>
        <ul className='social'>
          <li><i class="fa-brands fa-twitter"></i><a href='https://twitter.com/abhip05' className='sm'>Abhi Prajapati</a></li>
          <li><i class="fa-brands fa-linkedin"></i><a href='https://www.linkedin.com/in/kishanmunjpara' className='sm'>Kishan Munjpara</a></li>
          <li><i class="fa-brands fa-linkedin"></i><a href='https://www.linkedin.com/in/janakarpatel' className='sm'>Janakar Patel</a></li>
          <li><i class="fa-brands fa-linkedin"></i><a href='https://www.linkedin.com/in/krish-vasoya-9a139324b' className='sm'>Krish Vasoya </a></li>
        </ul>
      </footer>
    </div>
  );
};

export default Youtube;
